"use strict";

export default class EventController
{
	/*@ngInject*/
	constructor($http, $state, $stateParams, $translate, $uibModal, Auth, Modal, messageService)
	{
		this.$http = $http;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.Modal = Modal;
		this.$stateParams = $stateParams;
		this.isLoggedIn = Auth.isLoggedInSync;
		this.messageService = messageService;

		$http.post("/api/frontend/event/" + $stateParams.id)
		.then(response => {
			this.e = response.data; 
		})
		.catch(() => {
			$state.go("home");
		});
	}

	RemoveFromRace(race)
	{
		this.Modal.confirm.delete((/*Option params are passed here*/) => {
			this.$http.post("/api/frontend/event/unregister/" + race.id)
			.then(response => {
				// Reload inscriptions
				this.$http.post("/api/frontend/event/" + this.$stateParams.id)
				.then(response2 =>
				{
					this.messageService.Success(response.data);
					this.e = response2.data;
				});
			});
		})({
			header: 
			`<h3 style="margin-top:0; color:black!important">{{vm.e.title}}</h3>
			<h4 style='margin-bottom:0; color:white!important'>{{vm.r.desc}} <small> {{vm.r.name}}</small></h4>`,
			html: ["{{'EVENT_CancelRegistrationWarning'|translate}}"],
			btnAccept: "EVENT_CancelRegistration",
			vm: {e: this.e, r: race}
		}/*Optional params here*/);
	}
	
	OpenModal(race) 
	{
		var modalInstance = this.$uibModal.open(
		{
			template: require("./eventregister.html"),
			controller: "RegisterController",
			controllerAs: "vm",
			size: 200,
			resolve: {
				parent: () => { return { e: this.e, r: race, t: this.transponders }; }
			}
		});
			
		modalInstance.result.then((result) =>
		{
			this.$http.post("/api/frontend/event/register/" + race.id, result.d)
			.then(response => 
			{
				// Reload inscriptions
				this.$http.post("/api/frontend/event/" + this.$stateParams.id)
				.then(response2 => {
					this.messageService.Success(response.data);
					this.e = response2.data; 
				});
			})
			.catch((err) => {
				this.messageService.Error(err.data);
			});
		}, () => {
			// No borrar esta funcion porque sino angular se queja de unhandled rejection
		});
	}
}



// WEBPACK FOOTER //
// ./client/app/frontend/event/event.controller.js